import { Popup } from "./class";

const burgerPopup = new Popup(".burger-menu", {
  closeOnResize: true,
  openButtons: ".burger-icon",
});

document
  .querySelectorAll(".burger-menu.backdrop .nav-list a")
  .forEach((link) => {
    link.addEventListener("click", () => burgerPopup.close());
  });
